import React from 'react';
import { Card } from 'components/cards/Card';
import { Text } from 'components/typography';
import { ShouldRender } from 'components/ShouldRender';
import CloseIcon from 'assets/icons/close-icon.svg';
import { useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { useDeleteBooking } from 'services/laundry/delete-booking';
import { Button } from '../../../../../../../../../form-elements/buttons/Button';
import styles from './styles.module.scss';

const capitalizeWords = (str) => str.replace(/\b[a-zA-ZåäöÅÄÖ]+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));

const formatDateWithLocale = (date, locale) => {
  if (!date) return '';
  const formatted = new Date(date).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
  });
  return capitalizeWords(formatted);
};

export const BookingCard = ({
  bookingId,
  name,
  fullDate,
  from,
  to,
  address,
  fullEndDate,
  showRange,
  icon,
  isPast = false,
}) => {
  const intl = useIntl();
  const { openModal } = useModal();
  const { deleteBooking, isLoading } = useDeleteBooking();

  const date = formatDateWithLocale(fullDate, intl.locale);
  const endDate = formatDateWithLocale(fullEndDate, intl.locale);

  const handleDeleteClick = () => {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage({
          id: 'deleteBookingConfirm',
        }),
        content: intl.formatMessage({
          id: 'deleteBookingConfirmContent',
        }),
        onConfirm: () => deleteBooking(bookingId),
      },
    });
  };

  return (
    <Card
      grey
      className={`${styles.card} ${isPast ? styles.pastBooking : ''}`}
    >
      <div className={styles.icon}>{icon}</div>

      <div className={styles.content}>
        <Text
          bold
          size={18}
        >
          {name}
        </Text>

        <ShouldRender condition={!showRange}>
          <div className={styles.inlineText}>
            <Text
              size={15}
              bold
            >
              {date}
            </Text>
            <Text size={15}>
              {from} - {to}
            </Text>
          </div>
        </ShouldRender>

        <ShouldRender condition={showRange}>
          <div className={styles.inlineText}>
            <Text size={15}>
              <span
                style={{
                  fontWeight: 'bold',
                }}
              >
                {date}
              </span>{' '}
              {from} -
              <span
                style={{
                  fontWeight: 'bold',
                }}
              >
                {` ${endDate}`}
              </span>{' '}
              {to}
            </Text>
          </div>
        </ShouldRender>

        <Text size={15}>{address}</Text>
      </div>

      <ShouldRender condition={!isPast}>
        <Button
          className={styles.removeBookingBtn}
          onClick={handleDeleteClick}
          loading={isLoading}
        >
          <img
            src={CloseIcon}
            alt="red close icon"
          />
        </Button>
      </ShouldRender>
    </Card>
  );
};
